import Box from "@mui/material/Box";
import { useSnackbar } from "notistack";
import Stack from "@mui/material/Stack";
import DialogModal from "../../../../../../atoms/dialog";
import CustomBtnFilled from "../../../../../../atoms/form-molecules/CustomBtnFilled";
import { ElementRef, useRef } from "react";
import { copyHtml } from "../../../../../../utils/copyHtml";
import { SharedProfiles } from "../../../type";
import EmailFormatDialog from ".";
import { BoxFlex } from "../../../../../../atoms/boxSpaceBtw";
import { CLIENT_IMPORTANT_NOTES } from "./helper";



type Props = {
    isOpen: boolean;
    handleClose: () => void;
    experts: SharedProfiles[];
    handleReArrangeExpert: (experts: SharedProfiles[]) => void;
    client_id?: number
}
// Configuration object for client-specific important notes

const EmailFormatDialogBulk = ({ isOpen, handleClose, experts , handleReArrangeExpert, client_id}: Props) => {

 // Get important notes for the current client
    const importantNotes = client_id ? CLIENT_IMPORTANT_NOTES[client_id] : null;
    const componentRef = useRef<ElementRef<"div">>(null);

    const { enqueueSnackbar } = useSnackbar();

    const handleCopyToClipboard = async () => {
        await copyHtml(componentRef, enqueueSnackbar);
    };


    return (
        <DialogModal
            isOpen={isOpen}
            handleClose={handleClose}
            title={"Expert Details"}
            titleSx={{ paddingTop: "0" }}
            TitleEl={
                <BoxFlex sx={{gap: "1rem"}}>
                    <CustomBtnFilled
                        label="ReArrange Experts"
                        variant="contained"
                        onClick={() => {
                            handleClose();
                            handleReArrangeExpert(experts);
                        }}
                    />
                    <CustomBtnFilled
                        label="Copy to clipboard"
                        variant="outlined"
                        onClick={handleCopyToClipboard}
                    />
                </BoxFlex>
            }
        >
            <Stack mt={"10px"} sx={{
                fontFamily: `"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
            "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
            "Helvetica Neue", sans-serif`,
                "& p": {
                    fontSize: "14px"
                }
            }}
                flexDirection={"column"}
                ref={componentRef}
            >
                {experts.map((val,index) =>
                    <div>
                        <EmailFormatDialog
                            isOpen={isOpen}
                            handleClose={handleClose}
                            expert_id={val.expert_id}
                            relevant_company={val.company}
                            relevant_designation={val.designation}
                            snippet={val.snippet}
                            charges={val.charges}
                            meta={val.meta}
                            forBulk={true}
                            isBulkFirst={index === 0}
                            client_id={client_id}
                        />
                        <br />
                        <hr />
                    </div>
                )}
                {
                importantNotes ? (
                    <div
                        style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef",
                            borderRadius: "8px",
                            padding: "16px",
                            marginTop: "16px",
                            fontFamily: '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif'
                        }}
                    >
                        <div
                            style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#495057",
                                marginBottom: "8px"
                            }}
                        >
                            Please Note:
                        </div>
                        {importantNotes.map((note, index) => (
                            <div
                                key={index}
                                style={{
                                    fontSize: "13px",
                                    color: "#6c757d",
                                    marginBottom: index < importantNotes.length - 1 ? "4px" : "0",
                                    fontStyle: "italic"
                                }}
                            >
                                - {note}
                            </div>
                        ))}
                    </div>
                ) : null
            }
            </Stack>

        </DialogModal>
    )
}

export default EmailFormatDialogBulk